export enum StorageEnvType {
    AMBIENT = 1,
    COOLING = 2,
    FREEZING = 3
}